"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const ChatWidget = dynamic(
  () => import("./chat-widget").then((m) => ({ default: m.ChatWidget })),
  { ssr: false, loading: () => null },
);

/**
 * Defers loading the ~150 KB AI SDK chat bundle until after first paint.
 * Mounts when the browser is idle (or after 1.5s on browsers without
 * requestIdleCallback) so it never blocks LCP/TTI.
 */
export function ChatWidgetLoader() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    type IdleWindow = Window & {
      requestIdleCallback?: (
        cb: IdleRequestCallback,
        opts?: IdleRequestOptions,
      ) => number;
    };
    const w = window as IdleWindow;
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    let idleId: number | undefined;
    if (typeof w.requestIdleCallback === "function") {
      idleId = w.requestIdleCallback(() => setShow(true), { timeout: 2000 });
    } else {
      timeoutId = setTimeout(() => setShow(true), 1500);
    }
    return () => {
      if (timeoutId !== undefined) clearTimeout(timeoutId);
      if (idleId !== undefined && "cancelIdleCallback" in w) {
        (w as Window & { cancelIdleCallback?: (id: number) => void })
          .cancelIdleCallback?.(idleId);
      }
    };
  }, []);

  return show ? <ChatWidget /> : null;
}
